import { Github, Linkedin, Mail, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import { Newsletter } from "./Newsletter";
import { VestnLogo } from "./VestnLogo";

export const FooterNew = () => {
  return (
    <footer className="bg-card border-t border-border print:hidden">
      <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <VestnLogo size="md" className="mb-4" />
            <p className="text-sm text-muted-foreground leading-relaxed mb-6 max-w-sm">
              Tokenizing premium real-world assets. Democratizing access to
              institutional-grade investments through blockchain technology.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://twitter.com/vestn"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary/20 hover:text-primary transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com/company/vestn"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary/20 hover:text-primary transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://github.com/vestn"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary/20 hover:text-primary transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="mailto:contact@vestn.io"
                className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary/20 hover:text-primary transition-colors"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Platform</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/primarymarketplace"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Primary Marketplace
                </Link>
              </li>
              <li>
                <Link
                  to="/secondary-marketplace"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Secondary Marketplace
                </Link>
              </li>
              <li>
                <Link
                  to="/rental"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Yield
                </Link>
              </li>
              <li>
                <Link
                  to="/platform"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Platform
                </Link>
              </li>
              <li>
                <Link
                  to="/how-to-use"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  How to use?
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Press
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Partners
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/risk-disclosure"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Risk Disclosure
                </Link>
              </li>
              <li>
                <Link
                  to="/regulatory-compliance"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Regulatory Compliance
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <Newsletter variant="footer" />
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            <p className="text-xs text-muted-foreground text-center lg:text-left">
              © {new Date().getFullYear()} VESTN Inc. All rights reserved.{" "}
              <span className="text-vestn-pending ml-2">IMPORTANT:</span> This
              is for informational purposes only and does not constitute
              investment advice.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-muted-foreground">
                Powered by Blockchain Technology
              </span>
              <div className="flex items-center gap-1">
                <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                <span className="text-xs text-primary font-medium">
                  Network Active
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
